import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';

@Component({
  selector: 'app-marine-accept-transit-date',
  templateUrl: './marine-accept-transit-date.component.html',
  styleUrls: ['./marine-accept-transit-date.component.css']
})
export class MarineAcceptTransitDateComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  marineAcceptanceForm: FormGroup;
  displayedLang: Languages;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest// = new BaseRequest();
  submitted: boolean = false;
  user: User = new User();
  showRequest: boolean = false;
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();
  @ViewChild('transitRequest',{static: false}) transitRequest: TransitRequestComponent;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService, private adminSrv: TransitAdminService,
    private authenticationService: AuthenticationService, private alertService: AlertService) {
    this.displayedLang = this.globalSrv.getLanguage()
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }
    else{
      window.history.back();
    }
    this.user = this.globalSrv.user;
    // this.baseRequestId = '47F8B6D4-7F34-4234-8377-35262235A57A';

  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.marineAcceptanceForm = this.formBuilder.group({
      Accepted: ['', [Validators.requiredTrue]],
    });

  }
  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        if (this.requestStatus == ServiceStatus.PendingOnTransitDates) {
          this.formMode = FormMode.Add;
          this.marineAcceptanceForm.enable();

        }
        else if (history.state.data && history.state.data.isCompleted) {
          this.marineAcceptanceForm.patchValue({
            Accepted: true,

          });
          this.formMode = FormMode.Readonly;
          this.marineAcceptanceForm.disable();
        }
        else {
          this.marineAcceptanceForm.patchValue({
            Accepted: true,

          });
          this.formMode = FormMode.Readonly;
          this.marineAcceptanceForm.disable();
        }

      }
    )
  }

  get f() {
    return this.marineAcceptanceForm.controls;
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.marineAcceptanceForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    //this.adminDecisionObject = this.marineAcceptanceForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.RequestId = this.baseRequestId;
    this.adminDecisionObject.TransitDate = this.transitRequest.feesRequest.feesDetailsForm.controls.TransitDate.value

    this.adminSrv.AddMarineAcceptance(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.marineAcceptanceForm.reset();
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));
          }

        });
  }



}
